import React from 'react';
import TeamMemberAboutContainer from './about/TeamMemberAboutContainer';
import TeamContactLinksContainer from './links/TeamContactLinksContainer';
import TeamLeadCaptureContainer from './leadCapture/TeamLeadCaptureContainer';
import TeamFollowUpEmailContainer from './followUpEmail/TeamFollowUpEmailContainer';
import TeamQRCodeContainer from './qrCode/TeamQRCodeContainer';
import TeamVirtualBackgroundContainer from './virtualBackground/TeamVirtualBackgroundContainer';
import TeamEmailSignatureContainer from './emailSignature/TeamEmailSignatureContainer';
import TeamAccessoriesContainer from './accessories/TeamAccessoriesContainer';
import TeamProductsAndServicesContainer from './links/productsServices/TeamProductsAndServicesContainer';

const TeamMemberEditContent = ({ selectedItem, user, setSelectedItem }) => {
    return (
        <>
            {/* Always render TeamMemberAboutContainer but conditionally show/hide */}
            <div style={{ display: selectedItem === 'about' ? 'block' : 'none' }}>
                <TeamMemberAboutContainer user={user} setSelectedItem={setSelectedItem} />
            </div>

            {/* Render other components conditionally */}
            {selectedItem === 'links' && <TeamContactLinksContainer user={user} />}
            {selectedItem === 'productsAndServices' && <TeamProductsAndServicesContainer />}
            {selectedItem === 'leadCaptureForm' && <TeamLeadCaptureContainer />}
            {selectedItem === 'followUpEmail' && <TeamFollowUpEmailContainer />}
            {selectedItem === 'qrCode' && <TeamQRCodeContainer />}
            {selectedItem === 'virtualBackground' && <TeamVirtualBackgroundContainer />}
            {selectedItem === 'emailSignature' && <TeamEmailSignatureContainer user={user} />}
            {selectedItem === 'accessories' && <TeamAccessoriesContainer />}
        </>
    );
};

export default TeamMemberEditContent;

